import React, { Component } from "react";
import { FormField } from "react-form";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormHelperText from "@material-ui/core/FormHelperText";

import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
    input: {
        display: "none",
    },
    inline: {
        display: "inline",
        marginLeft: 16,
    },
    linkColor: {
        color: "#2b6dad",
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "#F9EBC8",
        },
    },
    red: {
        color: "red",
    },
    button: {
        marginTop: 10,
        position: "absolute",
    },
});

// See https://react-form.js.org/#/custom-input
class FileInputWrapper extends Component {
    constructor(props, context) {
        super(props, context);
        this.inputRef = React.createRef();

        var val = this.props.fieldApi.getValue();
        this.state = {
            displayLabel: val,
            useUrl: val ? true : false
        };
    }

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };


    ingestFile = async (file) => {
        if (!file) return;
        const { customaccept, fieldApi, eventHandle } = this.props;
        const { setValue } = fieldApi;

        const accepted = customaccept
            ? customaccept.replaceAll(".", "").split(",")
            : ["application/hcp", "pdf", "tiff", "tif", "png", "jpg", "jpeg", "jpe", "bmp", "ppt", "pptx", "mp4", "mov", "3gp", "msg", "zip", "rar", "xls", "xlsx", "xlb", "doc", "docx", "txt", "rtf", "hcp"];
        const ext = (file.name.match(/(?:\.([^.]+))?$/)?.[1] || "").toLowerCase();
        if (!accepted.includes(ext)) { alert("Invalid File Type. Please upload as a .zip file."); return; }
        if (file.size > 70000000) { alert("File Size is limited to under 70MB."); return; }

        let value = file;
        if (ext === "hcp") value = new File([file], file.name, { type: "application/hcp" });

        this.setState({ displayLabel: value.name, useUrl: false, base64Loading: true });
        const data = await this.getBase64(value);
        setValue(data);
        fieldApi.setTouched && fieldApi.setTouched(true);
        fieldApi.setError && fieldApi.setError(undefined);
        if (eventHandle) eventHandle(value);
        this.setState({ base64Loading: false });
    };

    handleChange = (e) => {
        const f = e.target.files[0];
        if (!f) return;
        this.ingestFile(f);
    };

    componentDidUpdate(prevProps) {
        if (this.props.externalFile && this.props.externalFile !== prevProps.externalFile) {
            const f = this.props.externalFile;

            if (this.inputRef.current) {
                try {
                    const dt = typeof DataTransfer !== 'undefined' ? new DataTransfer()
                        : (typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('').clipboardData : null);
                    if (dt) {
                        dt.items.add(f);
                        this.inputRef.current.files = dt.files;
                        this.inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                } catch (_) {
                    // Nothing to see here. 
                }
            }
            this.ingestFile(f);
        }
    }

    removeFile = () => {
        const { fieldApi, eventHandle } = this.props;
        const { setValue } = fieldApi;

        this.setState({ displayLabel: null, useUrl: false });
        setValue(null);
        if (this.inputRef.current) this.inputRef.current.value = "";
        this.props.fieldApi.setError && this.props.fieldApi.setError(undefined);
        if (eventHandle) {
            eventHandle(null);
        }
    };

    handleViewFile = async (e) => {
        const { downloadUrl } = this.props;
        if (!downloadUrl) return;
        e.preventDefault();
        try {
            const urlParams = new URLSearchParams(downloadUrl.split("?")[1] || "");
            const filename = urlParams.get("filename") || "template.docx";
            const response = await fetch(downloadUrl);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
        }
    };

    render() {
        const { classes, label, children, id, fieldApi, customaccept, downloadUrl, ...rest } = this.props;
        const { displayLabel, base64Loading, useUrl } = this.state;
        const { getError, getWarning, getSuccess } = fieldApi;



        const error = getError(),
            warning = getWarning(),
            success = getSuccess(),
            hasError = !!error,
            errorText = error || warning || success;


        return (
            <>
                <div style={{ display: "inline" }}>
                    <Typography gutterBottom>{label || children}</Typography>
                    <input
                        ref={this.inputRef}
                        name="file"
                        accept={customaccept ? customaccept : "application/hcp,.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.tiff,.bmp,.ppt,.pptx,.zip,.hcp,.msg"}
                        className={classes.input}
                        id={id}
                        type="file"
                        onChange={this.handleChange}
                        {...rest}
                    />
                    <label htmlFor={id}>
                        {base64Loading && <Typography className={classes.button}>Please wait...</Typography>}

                        <Button
                            disabled={rest.readOnly || base64Loading}
                            raised
                            component="span"
                            className={hasError && !displayLabel && classes.red}>
                            {useUrl ? "Reupload New File" : "Select File"}
                        </Button>
                    </label>
                    <Typography className={classes.inline}>
                        {useUrl && (
                            <>
                                <a
                                    className={classes.linkColor}
                                    href={downloadUrl || displayLabel}
                                    onClick={downloadUrl ? this.handleViewFile : undefined}
                                    {...(!downloadUrl && { target: "_blank", rel: "noopener noreferrer" })}>
                                    View File
                                </a>
                            </>
                        )}
                        {!useUrl && displayLabel && (
                            <span>{displayLabel}</span>
                        )}

                    </Typography>
                </div>
                {hasError && !displayLabel && (
                    <FormHelperText style={{ display: "inline" }} error={true}>
                        {errorText}
                    </FormHelperText>
                )}
            </>
        );
    }
}
FileInputWrapper.displayName = "FileInputWrapper";
const FileInput = FormField(FileInputWrapper);

export default withStyles(styles)(FileInput);
